export default __webpack_public_path__ + "sorter.23b13d85681dc84e.svg";